import React from 'react'
import { toColor, getInitials } from 'utils'
import messages from './messages'
import {FormattedMessage, useIntl} from 'react-intl'
import Icon from 'components/Icon'

const TeamUserCard = ({ name, username, email, admin, image, onAdded, onRemoved }) => (
  <li className={`group bg-white rounded-sm shadow-sm w-full flex items-center justify-between p-4 space-x-6 border border-gray-200 ${(onAdded || onRemoved) ? 'opacity-75' : ''}`}>
    <div className="flex-1 truncate">
      <div className="flex items-center space-x-3">
        <h3 className="text-gray-900 text-sm font-medium truncate">{ name }</h3>
        { admin &&
          <span className="shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-green-100 rounded-full"><FormattedMessage {...messages.admin}/></span>
        }
      </div>
      <p className="mt-1 text-sm truncate space-x-3 text-white group-hover:text-primary">
        <span className="text-gray-500">@{ username }</span>
        <a href={`mailto:${email}`} className="text-white group-hover:text-primary hover:text-primary-darker" tile={email}>{ email }</a>
      </p>
    </div>

    { onAdded ? (
      <button
        type="button"
        className="w-10 h-10 bg-gray-300 hover:bg-primary rounded-full shrink-0 flex items-center justify-center text-white font-medium"
        onClick={onAdded}
      >
        <Icon icon="plus" />
      </button>
    ) : onRemoved ? (
      <button
        type="button"
        className="w-10 h-10 bg-red-200 hover:bg-primary rounded-full shrink-0 flex items-center justify-center text-white font-medium"
        onClick={onRemoved}
      >
        <Icon icon="times" />
      </button>
    ) : image ? (
      <img className="w-10 h-10 bg-gray-300 rounded-full shrink-0" src={image} alt="" />
    ) : (
      <div className={`w-10 h-10 ${toColor(name)} rounded-full shrink-0 flex items-center justify-center text-white font-medium text-sm`}>
        { getInitials(name) }
      </div>
    ) }
  </li>
)

export default TeamUserCard
